/* eslint react/forbid-prop-types: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import {
  ProductPod,
  ProductBadge,
  ProductImage, PodSection, PodSpacer, PodFooter
} from '@thd-olt-component-react/product-pod';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { Button } from '@one-thd/sui-atomic-components';
import { Price } from '@thd-olt-component-react/price';

export const ListRecsPod = ({
  itemId,
  podIndex,
  storeId,
  onIntentResolved
}) => {
  return (
    <div data-component="ListRecsPod">
      <ProductPod
        itemId={itemId}
        storeId={storeId}
        analyticsData={{
          parent: 'product-list', position: podIndex
        }}
        render={(pod) => (
          <>
            <div className="sui-grid sui-grid-cols-7 sui-gap-1">
              <div className="sui-col-span-3">
                <PodSection padding="sui-p-0" noPadding columnAlign relative>
                  <PodSpacer padding={['BOTTOM', 'RIGHT']}>
                    <PodSpacer padding={['BOTTOM']}>
                      <ProductBadge itemId={pod.itemId} storeId={storeId} />
                    </PodSpacer>
                    <ProductImage itemId={pod.itemId} />
                  </PodSpacer>
                </PodSection>
              </div>
              <div className="sui-col-span-4">
                <ProductHeader
                  brand="inline"
                  itemId={pod.itemId}
                  brandTitleMaxLine={3}
                  disableShopThisCollection
                />
                <PodSpacer padding={['TOP', 'BOTTOM']}>
                  <Price
                    itemId={pod.itemId}
                    storeId={storeId}
                    large={false}
                    type="simple"
                    hideBadge
                    hideWhenZero
                    hideBulkPrice
                    hideLimitPerOrder
                    hideSavingsText
                    hidePromotions
                    stackWasPrice
                    omitDetails
                  />
                </PodSpacer>

              </div>
            </div>
            <PodFooter>
              <Button
                onClick={() => {
                  onIntentResolved({ itemId: pod.itemId });
                }}
                fullWidth
                variant="secondary"
              >Confirm
              </Button>
            </PodFooter>
          </>
        )}
      />
    </div>
  );
};

ListRecsPod.displayName = 'ListRecsPod';

ListRecsPod.propTypes = {
  itemId: PropTypes.string.isRequired,
  podIndex: PropTypes.number,
  storeId: PropTypes.string,
  onIntentResolved: PropTypes.func.isRequired
};

ListRecsPod.defaultProps = {
  podIndex: 1,
  storeId: ''
};

ListRecsPod.dataModel = extend(
  ProductPod,
  ProductImage,
  Price
);
